<script>
import isEmpty from 'lodash/isEmpty'
export default {
  props: {
    veeName: {
      type: String,
      require: false,
      default: '',
    },
    /**
     * rules vee-validate https://vee-validate.logaretm.com/v2/guide/rules.html
     */
    rules: {
      type: Object,
      require: false,
      default: () => {},
    },
    options: {
      type: Array,
      require: false,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  computed: {
    isValidate() {
      if (!isEmpty(this.rules)) {
        return 'is-valid'
      }
      return ''
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
  },
}
</script>

<template>
  <validation-provider
    v-slot="validationContext"
    :rules="rules"
    :name="veeName"
  >
    <div id="feelline-base-select">
      <CSelect
        ref="select"
        v-bind="$attrs"
        :[isValidate]="getValidationState(validationContext)"
        :invalid-feedback="validationContext.errors[0]"
        :options="options"
        :readonly="readonly"
        v-on="$listeners"
      >
        <template
          v-for="slot in [
            'prepend',
            'prepend-content',
            'append-content',
            'append',
            'label-after-input',
            'valid-feedback',
            'invalid-feedback',
            'description',
          ]"
          v-slot:[slot]
        >
          <slot :name="slot"></slot>
        </template>
      </CSelect>
    </div>
  </validation-provider>
</template>

<style lang="scss" scoped>
#feelline-base-select {
  ::v-deep .form-control {
    &.is-invalid {
      background-image: none;
    }
    &.is-valid {
      background-image: none;
    }
  }
}
</style>
